// src/pages/Login.js
import React, { useState } from "react";
import "./Login.css";

export default function Login({ onLogin }) {
  const [password, setPassword] = useState("");
  const handle = (e) => {
    e.preventDefault();
    if (password === process.env.REACT_APP_ADMIN_TOKEN || "IndoDef@2025") {
      localStorage.setItem("admin_auth", "1");
      onLogin();
    } else {
      alert("Invalid token");
    }
  };
  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={handle}>
        <h2>Admin Login</h2>
        <p>Enter admin token to continue</p>
        <input type="password" placeholder="Token" value={password} onChange={e=>setPassword(e.target.value)} />
        <button className="btn" type="submit">Login</button>
      </form>
    </div>
  );
}
